/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedSiteImageList } from '../models/PaginatedSiteImageList';
import type { PatchedSiteImage } from '../models/PatchedSiteImage';
import type { SiteImage } from '../models/SiteImage';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LeadsSitesImagesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedSiteImageList
     * @throws ApiError
     */
    public leadsSitesImagesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedSiteImageList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-sites-images/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns SiteImage
     * @throws ApiError
     */
    public leadsSitesImagesCreate({
        requestBody,
    }: {
        requestBody: SiteImage,
    }): CancelablePromise<SiteImage> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/leads-sites-images/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns SiteImage
     * @throws ApiError
     */
    public leadsSitesImagesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this site image.
         */
        id: number,
    }): CancelablePromise<SiteImage> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-sites-images/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns SiteImage
     * @throws ApiError
     */
    public leadsSitesImagesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this site image.
         */
        id: number,
        requestBody: SiteImage,
    }): CancelablePromise<SiteImage> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/leads-sites-images/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns SiteImage
     * @throws ApiError
     */
    public leadsSitesImagesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this site image.
         */
        id: number,
        requestBody?: PatchedSiteImage,
    }): CancelablePromise<SiteImage> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/leads-sites-images/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public leadsSitesImagesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this site image.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/leads-sites-images/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
